import { TRANSACTION_MAP } from "@constants/transaction"
import { client } from "@lib/api"
import { extractData } from "@lib/utils"
import useSWR from "swr"
import * as Sentry from "@sentry/react"

export type PaymentLinkActivityDetail = {
    uuid: string,
    total_amount: number,
    payment_link_status: string,
    payment_link: string,
    merchant_name: string,
    merchant_email: string,
    buyer_email: string,
    expiry_time: string,
    date: string
}

const usePaymentLinkActivityDetail = ({
    uuid,
    fetchImmediately = false
}: {
    uuid: string
    fetchImmediately?: boolean
}) => {
    const { data, isLoading, error } = useSWR(fetchImmediately ? `/wallet/payment-link/${uuid}` : null, 
        async (url: string) => {
            try {
                const response = await client.doGet(url)
                const activityDetail = extractData(response, 'new', 'paymentlink', TRANSACTION_MAP)
                return activityDetail
            } catch (error) {
                Sentry.captureException(error)
                throw error
            }
    })

    return {
        data,
        isLoading,
        error
    }
}

export default usePaymentLinkActivityDetail
